import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import './PrivacyPolicy.css';
import usePageSearchIndex from '../hooks/usePageSearchIndex';

const PrivacyPolicy = () => {
  const { isMarathi } = useLanguage();
  const navigate = useNavigate();

  const privacyData = {
    marathi: {
      title: 'गोपनीयता धोरण आणि अस्वीकरण',
      description: 'महाराष्ट्र कामगार कल्याण मंडळाचे गोपनीयता धोरण आणि अस्वीकरण',
      lastUpdated: 'शेवटचे अपडेट: 16 सप्टेंबर 2025',
      sections: [
        {
          question: 'गोपनीयता धोरण',
          answer: 'सर्वसाधारण नियमानुसार, हे पोर्टल तुमच्याकडून (जसे की, नाव, दूरध्वनी क्रमांक किंवा ई-टपालाचा पत्ता) अशी कोणतीही विनिर्दिष्ट वैयक्तिक माहिती आपोआप ग्रहण करू शकत नाही, ज्याद्वारे तुमची स्वतंत्रपणे ओळख पटविण्याची आम्हाला मुभा मिळू शकेल. हे पोर्टल तुमच्या भेटीचा अभिलेख ठेवते आणि सांख्यिकी प्रयोजनासाठी पुढील माहितीची जसे की, आंतरजाल नियमावली (आयपी) पत्ते, अधिक्षेत्राचे नाव, ब्राऊझरचा प्रकार, कार्यप्रणाली, भेट दिल्याची तारीख व वेळ आणि भेट दिलेली पृष्ठे यांची नोंद करते. या स्थळाला हानी पोहचविण्याचा प्रयत्न करणाऱ्याचा तपास लागेपर्यंत आमच्या स्थळाला भेट देणाऱ्यांची स्वतंत्रपणे ओळख पटविण्यासाठी या पत्त्यांशी संधान साधण्याचा कोणताही प्रयत्न आम्ही करत नाही. कायदे अंमलबजावणी अभिकरणाचा सेवा प्रदात्याच्या नोंदी तपासण्याबाबतचा लेखी आदेश असल्याशिवाय, वापरकर्त्याची किंवा त्याच्या ब्राऊझिंग क्रियांची ओळख आम्ही पटविणार नाही. महाराष्ट्र कामगार कल्याण मंडळ संकेतस्थळाने तुमच्याकडे वैयक्तिक माहिती पुरविण्याची विनंती केल्यास आणि तुम्ही ती देणे पसंत केल्यास ते कसे वापरावे याची माहिती तुम्हाला दिली जाईल आणि तुमच्या वैयक्तिक माहितीचे संरक्षण करण्यासाठी पुरेशी सुरक्षा प्रमाणके आचरली जातील.'
        },
        {
          question: 'माहिती संग्रह',
          answer: 'आम्ही केवळ आवश्यक असलेली माहिती संग्रहित करतो जी आमच्या सेवा प्रदान करण्यासाठी आवश्यक आहे. यात नाव, संपर्क माहिती, ईमेल पत्ता, फोन नंबर, डिव्हाइस माहिती, ब्राउझर माहिती, आयपी पत्ता, स्थान आणि इतर संबंधित माहितीचा समावेश होतो. आम्ही आपल्या परवानगीशिवाय कोणतीही अतिरिक्त माहिती संग्रहित करत नाही.'
        },
        {
          question: 'माहितीचा वापर',
          answer: 'संग्रहित केलेली माहिती केवळ आमच्या सेवा प्रदान करण्यासाठी वापरली जाते. यात कामगार कल्याण योजनांची अंमलबजावणी, संपर्क स्थापना, सेवा सुधारणा आणि कायदेशीर आवश्यकतांची पूर्तता यांचा समावेश होतो. आम्ही आपली माहिती तृतीय पक्षांसोबत सामायिक करत नाही.'
        },
        {
          question: 'माहिती संरक्षण',
          answer: 'आम्ही आपल्या माहितीचे संरक्षण करण्यासाठी उद्योग मानक सुरक्षा उपायांचा वापर करतो. यात एन्क्रिप्शन, सुरक्षित डेटा स्टोरेज, नियमित सुरक्षा ऑडिट्स आणि प्रवेश नियंत्रण यांचा समावेश होतो. तथापि, इंटरनेटवरील कोणतीही माहिती पूर्णपणे सुरक्षित असू शकत नाही.'
        },
        {
          question: 'कुकीज आणि ट्रॅकिंग',
          answer: 'आमची वेबसाइट वापरकर्त्यांचा अनुभव सुधारण्यासाठी कुकीज वापरते. या कुकीज वेबसाइटच्या कार्यक्षमतेसाठी आवश्यक आहेत आणि वापरकर्त्याच्या ब्राउझरमध्ये संग्रहित केल्या जातात. आपण आपल्या ब्राउझर सेटिंग्जमध्ये कुकीज अक्षम करू शकता.'
        },
        {
          question: 'बाह्य संकेतस्थळे / पोर्टल्सशी असलेल्या जोडण्या',
          answer: 'या पोर्टलवर अनेक ठिकाणी तुम्हाला अन्य संकेतस्थळांच्या / पोर्टलच्या इतर शासकीय, अशासकीय / खाजगी संस्थांनी निर्माण व परिरक्षित केलेल्या जोडण्या आढळून येतील. या जोडण्या तुमच्या सोईसाठी ठेवण्यात आलेल्या आहेत. जोडणीची निवड केल्यावर तुम्ही त्या संकेतस्थळामध्ये संचार करू शकता. त्याचक्षणी या संकेतस्थळावर तुम्ही या संकेतस्थळाच्या मालकाच्या / पुरस्कर्त्याच्या गोपनीयता आणि सुरक्षेच्या धोरणांच्या अधीन असाल. जोडणीवरील संकेतस्थळाच्या मजकूरासाठी आणि विश्वसनीयतेबाबत महाराष्ट्र कामगार कल्याण मंडळ जबाबदार असणार नाही आणि त्यामधील हेतुबाबत अनावश्यक पुष्टीही देणार नाही. केवळ ही जोडणी असण्याबाबतचे किंवा या पोर्टलवरील यादीमधील तिचा समावेश हा कोणत्याही प्रकारच्या पृष्ठांकनासाठी गृहित धरला जाऊ नये.'
        },
        {
          question: 'महाराष्ट्र कामगार कल्याणक मंडळ संकेतस्थळाशी इतर संकेतस्थळे / पोर्टल्स याद्वारे असलेल्या जोडण्या',
          answer: 'आमच्या स्थळावर आयोजित केलेली माहिती तुम्ही थेट जोडणीद्वारे घेण्याविषयी आमची कोणतीही हरकत नाही आणि त्यासाठी कोणत्याही पूर्वपरवानगीची आवश्यकता नाही. तुमच्या स्थळावरील चौकटींमध्ये आमची पृष्ठे भरण्यासाठी आम्ही अनुमती देऊ शकत नाही. आमच्या विभागाची पृष्ठे ही केवळ वापरकर्त्याच्या नव्याने उघडण्यात आलेल्या ब्राऊझरच्या चौकटीमध्येच भरली पाहिजेत.'
        },
        {
          question: 'जलद जोडण्याविषयीची धोरणे',
          answer: 'या पोर्टलवर अनेक ठिकाणी तुम्हाला अन्य संकेतस्थळांच्या / पोर्टलच्या इतर शासकीय, अशासकीय / खाजगी संस्थांनी निर्माण व परिरक्षित केलेल्या जोडण्या आढळून येतील. या जोडण्या तुमच्या सोईसाठी ठेवण्यात आलेल्या आहेत. जोडणीची निवड केल्यावर तुम्ही त्या संकेतस्थळामध्ये संचार करू शकता. त्याचक्षणी या संकेतस्थळावर तुम्ही या संकेतस्थळाच्या मालकाच्या / पुरस्कर्त्याच्या गोपनीयता आणि सुरक्षेच्या धोरणांच्या अधीन असाल.'
        },
        {
          question: 'स्वामित्व हक्क धोरण',
          answer: 'या पोर्टलवरील वैशिष्ट्यपूर्ण साहित्य विनाशुल्काने, कोणत्याही स्वरूपात किंवा माध्यमात विनिर्दिष्ट परवानगीच्या आवश्यकतेशिवाय उद्धृत करता येईल. साहित्य अचूकपणे उद्धृत करण्यावर आणि अप्रतिष्ठाकारक रितीचा किंवा दिशाभूल करणाऱ्या संदर्भाचा वापर न करण्यावर हे अवलंबून आहे. जेथे साहित्य प्रकाशित करावयाचे असेल किंवा इतरांना निर्गमित करावयाचे असेल तेथे स्त्रोतास ठळकपणे आभिस्वीकृत करणे आवश्यक आहे. तथापि त्रयस्थाचा स्वामित्व हक्क असलेले साहित्य अशी या स्थळावर ओळख पटविण्यात आलेल्या अशा कोणत्याही साहित्याच्या उद्धृतीकरणाचे प्राधिकारपत्र संबंधित स्वामित्व हक्क धारण करणाऱ्याकडून प्राप्त करण्यात यावे.'
        },
        {
          question: 'माहितीचे अधिकार',
          answer: 'आपल्याला आपल्या व्यक्तिगत माहितीवर अधिकार आहेत. आपण आपली माहिती पाहणे, सुधारणे, हटवणे किंवा माहितीच्या प्रक्रियेवर आक्षेप घेणे यासारखे अधिकार वापरू शकता. अशा विनंत्या करण्यासाठी आमच्याशी संपर्क साधा.'
        },
        {
          question: 'उत्तरदायित्त्वास नकार',
          answer: 'या संकेतस्थळावर उपलब्ध माहिती आणि मजकूर काळजीपूर्वक आणि परिश्रमपूर्वक उपलब्ध करुन देण्यात आला आहे. मात्र या माहितीचा वापर अथवा परिणामांची जबाबदारी महाराष्ट्र कामगार कल्याण मंडळ यांच्यावर राहणार नाही. कोणत्याही प्रकारची विसंगती अथवा संभ्रम आढळल्यास वापरकर्त्याने तपशीलवार स्पष्टीकरणासाठी संबंधित विभाग अथवा महाराष्ट्र कामगार कल्याण मंडळाशी संपर्क साधावा.'
        },
        {
          question: 'सेवा उपलब्धता',
          answer: 'मंडळ वेबसाइटच्या निरंतर उपलब्धतेची हमी देत नाही. तांत्रिक समस्या, देखभाल किंवा इतर कारणांमुळे सेवा तात्पुरत्या बंद असू शकते. अशा परिस्थितीत उद्भवणाऱ्या कोणत्याही नुकसानीसाठी मंडळ जबाबदार नाही.'
        },
        {
          question: 'धोरणात बदल',
          answer: 'मंडळ या गोपनीयता धोरणात कोणत्याही वेळी बदल करू शकते. कोणत्याही महत्त्वपूर्ण बदलांसाठी वेबसाइटवर सूचना प्रदान केली जाईल. धोरणातील बदलांना सहमती देण्यासाठी वेबसाइटचा वापर सुरू ठेवणे ही आपली जबाबदारी आहे.'
        },
        {
          question: 'संपर्क माहिती',
          answer: 'गोपनीयता धोरण किंवा अस्वीकरणाशी संबंधित कोणत्याही प्रश्नांसाठी, कृपया आमच्याशी संपर्क साधा: महाराष्ट्र कामगार कल्याण मंडळ, मुंबई. ईमेल: info@mlwb.in, फोन: 022-12345678'
        }
      ]
    },
    english: {
      title: 'Privacy Policy and Disclaimer',
      description: 'Privacy Policy and Disclaimer of Maharashtra Labour Welfare Board',
      lastUpdated: 'Last Updated: September 16, 2025',
      sections: [
        {
          question: 'Privacy Policy',
          answer: 'As a general rule, this portal does not automatically capture any specific personal information from you, (like name, phone number or e-mail address), that allows us to identify you individually. This portal records your visit and logs the following information for statistical purposes, such as Internet Protocol (IP) addresses, domain name, browser type, operating system, the date and time of the visit and the pages visited. We make no attempt to link these addresses with the identity of individuals visiting our site unless an attempt to damage the site has been detected. We will not identify users or their browsing activities, except when a law enforcement agency may exercise a warrant to inspect the service provider\'s logs. If Maharashtra Labour Welfare Board portal requests you to provide personal information, you will be informed how it will be used if you choose to give it and adequate security measures will be taken to protect your personal information.'
        },
        {
          question: 'Information Collection',
          answer: 'We collect only necessary information that is required to provide our services. This includes name, contact information, email address, phone number, device information, browser information, IP address, location, and other relevant details. We do not collect any additional information without your consent.'
        },
        {
          question: 'Use of Information',
          answer: 'The collected information is used solely for providing our services. This includes implementation of labour welfare schemes, establishing contact, service improvements, and fulfilling legal requirements. We do not share your information with third parties.'
        },
        {
          question: 'Information Protection',
          answer: 'We use industry-standard security measures to protect your information. This includes encryption, secure data storage, regular security audits, and access controls. However, no information on the internet can be completely secure.'
        },
        {
          question: 'Cookies and Tracking',
          answer: 'Our website uses cookies to improve user experience. These cookies are necessary for website functionality and are stored in the user\'s browser. You can disable cookies in your browser settings.'
        },
        {
          question: 'Links to External Websites/Portals',
          answer: 'At many places in this portal, you shall find links to other websites/portals created and maintained by other Government, non-Government / private organizations. These links have been placed for your convenience. When you select a link you are navigated to that website. Once on that website, you are subject to the privacy and security policies of the owners / sponsors of the website. Maharashtra Labour Welfare Board is not responsible for the contents and reliability of the linked websites and does not necessarily endorse the views expressed in them. Mere presence of the link or its listing on this portal should not be assumed as endorsement of any kind.'
        },
        {
          question: 'Links to the Maharashtra Labour Welfare Board Website by Other Websites/Portals',
          answer: 'We do not object you for linking directly to the information that is hosted on our site and no prior permission is required for the same. We do not permit our pages to be loaded into frames on your site. Our Department\'s pages must load into a newly opened browser window of the user.'
        },
        {
          question: 'Hyperlinking Policy',
          answer: 'At many places in this portal, you shall find links to other websites/portals created and maintained by other Government, non-Government / private organizations. These links have been placed for your convenience. When you select a link you are navigated to that website. Once on that website, you are subject to the privacy and security policies of the owners / sponsors of the website.'
        },
        {
          question: 'Copyright Policy',
          answer: 'Material featured on this portal may be reproduced free of charge in any format or media without requiring specific permission. This is subject to the material being reproduced accurately and not being used in a derogatory manner or in a misleading context. Where the material is being published or issued to others, the source must be prominently acknowledged. However, the permission to reproduce this material does not extend to any material on this site which is identified as being the copyright of the third party. Authorization to reproduce such material is obtained from the copyright holders concerned.'
        },
        {
          question: 'Information Rights',
          answer: 'You have rights over your personal information. You can exercise rights such as viewing, modifying, deleting your information, or objecting to information processing. Contact us to make such requests.'
        },
        {
          question: 'Disclaimer',
          answer: 'Although the information and contents in this website have been put with care and diligence, Maharashtra Labour Welfare Board does not take responsibility on how this information is used or the consequences of its use. In case of any inconsistency/confusion, the user should contact the concerned Section/Officer of Maharashtra Labour Welfare Board for further clarifications.'
        },
        {
          question: 'Service Availability',
          answer: 'The Board does not guarantee continuous availability of the website. Services may be temporarily unavailable due to technical issues, maintenance, or other reasons. The Board is not responsible for any damages arising in such situations.'
        },
        {
          question: 'Policy Changes',
          answer: 'The Board may modify this privacy policy at any time. Notices will be provided on the website for any significant changes. It is your responsibility to continue using the website to consent to policy changes.'
        },
        {
          question: 'Contact Information',
          answer: 'For any questions related to privacy policy or disclaimer, please contact us: Maharashtra Labour Welfare Board, Mumbai. Email: info@mlwb.in, Phone: 022-12345678'
        }
      ]
    }
  };

  const content = isMarathi() ? privacyData.marathi : privacyData.english;

  useEffect(() => {
    // Reserved for future non-search side effects if needed
  }, []);

  // Auto-index Privacy Policy content for search
  usePageSearchIndex({
    mr: ['गोपनीयता', 'गोपनीयता धोरण', 'अस्वीकरण', 'धोरण', 'माहिती', 'संरक्षण', 'कुकीज'],
    en: ['privacy policy', 'privacy policy and disclaimer', 'privacy', 'disclaimer', 'policy', 'information', 'protection', 'cookies']
  });

  const pageHeaderData = {
    title: {
      marathi: content.title,
      english: content.title
    },
    subtitle: {
      marathi: content.description,
      english: content.description
    }
  };

  const handleContactClick = () => {
    navigate('/contact');
  };

  return (
    <div className="privacy-policy-page">
      <div className="privacy-policy-container">
        {/* Page Header */}
        <PageHeader 
          title={pageHeaderData.title}
          subtitle={pageHeaderData.subtitle}
        />

        <div className="privacy-policy-content" data-read-section="privacy-policy-content">
          {content.sections.map((section, index) => (
            <div key={index} className="privacy-policy-section">
              <h3 className="privacy-policy-section-title">{section.question}</h3>
              <p className="privacy-policy-section-answer">{section.answer}</p>
            </div>
          ))}
        </div>

        <div className="privacy-policy-footer">
          <p className="privacy-policy-note" onClick={handleContactClick}>
            {isMarathi() 
              ? 'गोपनीयता धोरणाशी संबंधित कोणत्याही प्रश्नांसाठी, कृपया आमच्याशी संपर्क साधा.'
              : 'For any questions related to privacy policy, please contact us.'
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
